import { styled } from '@ori-ui/mui';
export const Root = styled('div')((param)=>{
    let { theme } = param;
    return {
        background: theme.palette.background.default
    };
});
